var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-full max-w-layout mx-auto"
  }, [_c('div', {
    staticClass: "fixed hidden tab:block top-0 h-full w-12"
  }, [_c('button', {
    staticClass: "h-1/2 w-full flex mb-2 flex-col items-center justify-end text-gray-5 hover:text-gray-4 transition",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Скролл вверх")]), _vm._v(" "), _c('CoreIcon', {
    staticClass: "w-6 h-6 fill-current transform rotate-180 transition-transform",
    attrs: {
      "name": "arrow-down"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "h-1/2 w-full mt-2 flex flex-col items-center justify-start text-gray-5 hover:text-gray-4 transition",
    on: {
      "click": _vm.scrollToBottom
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Скролл вниз")]), _vm._v(" "), _c('CoreIcon', {
    staticClass: "w-6 h-6 fill-current",
    attrs: {
      "name": "arrow-down"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "w-full max-w-content-full-profile tab:ml-12"
  }, [_c('div', {
    staticClass: "tab:mt-2.5 tab:rounded-xl overflow-hidden relative z-10"
  }, [_vm._t("cover")], 2), _vm._v(" "), _c('div', {
    staticClass: "flex flex-wrap tab-l:flex-nowrap w-full pt-2.5 pb-6"
  }, [_c('div', {
    staticClass: "w-full max-w-content-sm"
  }, [_c('div', [_c('div', {
    staticClass: "-mt-14"
  }, [_vm._t("header")], 2), _vm._v(" "), _vm._t("main")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "aside w-full tab:w-right-column-profile tab:ml-5 mt-6 tab:mt-0 shrink-0"
  }, [_c('NuxtjsStickySidebar', {
    staticClass: "sidebar",
    attrs: {
      "top-spacing": _vm.topSpacing,
      "bottom-spacing": 24,
      "container-selector": ".aside"
    }
  }, [_vm._t("column")], 2)], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }